const ToolsData=[
    {
        duration:1000,
        img: "/images/github-removebg-preview.png",
        name: "Github"
      },
      
      {
        duration:1600,
        img: "/images/postman.png",
        name: "Postman"
      },
      {
        duration:2200,
        img: "/images/aws.png",
        name: "AWS"
      },

    ];
    export default ToolsData;